// Generated types for InterfaceDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from './sysmlstructure';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from './sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InterfaceDefinitionReadAPI extends SysMLStructureReadAPI {
}

export interface InterfaceDefinitionWriteAPI extends SysMLStructureWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InterfaceDefinitionReadAPISchema: z.ZodType<InterfaceDefinitionReadAPI> = SysMLStructureReadAPISchemaObject.extend({}).passthrough();

export const InterfaceDefinitionWriteAPISchema: z.ZodType<InterfaceDefinitionWriteAPI> = SysMLStructureWriteAPISchemaObject.extend({}).passthrough();
